import { useWindowDimensions } from 'react-native';
import { isPhone } from '@helpers';
import { LIST_WIDTH } from '@v2/pages/common/constants/base.constants';
import { TimelineSizes } from '@interfaces/timeline';

interface UseTimelineSizesParams {
  fullScreen?: boolean;
}

export const useTimelineSizes = ({ fullScreen = true }: UseTimelineSizesParams = {}): TimelineSizes => {
  const { width: fullWidth } = useWindowDimensions();

  const padding = 36;
  const detailsWidth = isPhone || fullScreen ? fullWidth : fullWidth - LIST_WIDTH;
  const blockWidth = detailsWidth - padding * 2;

  const popupWidthProductivityStatus = 735;
  const popupHeightProductivityStatus = 614;

  const popupWidthProductivityStatusLabel = 50;
  const popupWidthProductivityStatusLabelSymbolSize = 9;
  const popupHeightProductivityStatusLabel = 42;

  const popupWidthAlarm = 30;
  const popupWidthAlarmSymbolSize = 9;
  const popupHeightAlarm = 42;

  const popupWidthNcFileName = 60;
  const popupWidthNcFileNameSymbolSize = 14;
  const popupHeightNcFileName = 42;

  return {
    padding,
    detailsWidth,
    blockWidth,
    popupWidthProductivityStatus,
    popupHeightProductivityStatus,
    popupWidthProductivityStatusLabel,
    popupWidthProductivityStatusLabelSymbolSize,
    popupHeightProductivityStatusLabel,
    popupWidthAlarm,
    popupWidthAlarmSymbolSize,
    popupHeightAlarm,
    popupWidthNcFileName,
    popupWidthNcFileNameSymbolSize,
    popupHeightNcFileName,
  };
};
